(function () {
    'use strict';

    angular
        .module('emails')
        .controller('CampaignChooseTypeController', CampaignChooseTypeController);

    CampaignChooseTypeController.$inject = ['$state', '$stateParams'];


    function CampaignChooseTypeController($state, $stateParams) {
        var vm = this;

        function activate() {

        }

        activate();
    }

})();